import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {AppComponent} from './app.component';
import {ReactiveFormsModule} from '@angular/forms';
import {HttpClientModule} from '@angular/common/http';
import {InvalidatedLicenseComponent} from './invalidated-license/invalidated-license.component';
import {TenantUpdateComponent} from './tenant-update/tenant-update.component';
import {LicenseService} from './license.service';
import {RouterModule, Routes} from '@angular/router';
import {LicenseComponent} from './license/license.component';

const appRoutes: Routes = [
  {path: '', redirectTo: '/license', pathMatch: 'full'},
  {
    path: 'license',
    component: LicenseComponent,
  },
  {
    path: 'tenantUpdate',
    component: TenantUpdateComponent,
  },
  {
    path: 'invalidatedLicense',
    component: InvalidatedLicenseComponent
  },
  {path: '**', component: LicenseComponent}

];

@NgModule({
  declarations: [
    AppComponent,
    InvalidatedLicenseComponent,
    TenantUpdateComponent,
    LicenseComponent,
  ],
  imports: [
    BrowserModule,
    ReactiveFormsModule,
    HttpClientModule,
    RouterModule.forRoot(appRoutes),
  ],
  providers: [LicenseService],
  bootstrap: [AppComponent]
})
export class AppModule {
}
